import React, { useEffect, useState, useMemo } from "react";
import "./FilterSection.css";
import constellationSpecs from "./sat_db/constellationSpecs";
import RangeSlider from "./RangeSlider";

function FilterSection({ filter, handleFilterChange, scenario }) {
  const handleMouseDown = (event) => {
    event.stopPropagation();
  };

  const [constellations, setConstellations] = useState([]);
  const [resolutions, setResolutions] = useState([]);
  const [spectralTypes, setSpectralTypes] = useState([]);

  const [minResolution, maxResolution] = useMemo(() => {
    if (resolutions.length === 0) {
      return [0, 0];
    }
    return [Math.min(...resolutions), Math.max(...resolutions)];
  }, [resolutions]);

  const normalizedResolution = useMemo(() => {
    if (!Array.isArray(filter.resolution)) {
      return [minResolution, maxResolution];
    }
    return [
      Math.max(minResolution, Number(filter.resolution[0])),
      Math.min(maxResolution, Number(filter.resolution[1])),
    ];
  }, [filter.resolution, minResolution, maxResolution]);

  const resolutionFilterIsActive =
    normalizedResolution[0] > minResolution || normalizedResolution[1] < maxResolution;

  const handleResolutionChange = (event, newValue) => {
    handleFilterChange({
      target: {
        name: "resolution",
        value: newValue,
      },
    });
  };

  useEffect(() => {
    const uniqueConstellations = Object.keys(constellationSpecs).sort();
    const uniqueResolutions = [...new Set(Object.values(constellationSpecs).map((spec) => spec.resolution))];
    const uniqueSpectralTypes = [...new Set(Object.values(constellationSpecs).map((spec) => spec.spectral_range))].sort();
  
    setConstellations(uniqueConstellations);
    setResolutions(uniqueResolutions);
    setSpectralTypes(uniqueSpectralTypes);
  }, []);

  useEffect(() => {
    if (resolutions.length === 0 || Array.isArray(filter.resolution)) {
      return;
    }

    handleFilterChange({
      target: {
        name: "resolution",
        value: [minResolution, maxResolution],
      },
    });
  }, [filter.resolution, handleFilterChange, maxResolution, minResolution, resolutions.length]);
  
  const isSkySatScenario = scenario === "case1";
  

  return (
    <div className="filter-section" onMouseDown={handleMouseDown}>
      <div style={{ fontWeight: "bold", textAlign: "center" }}>Filter</div>
      <label htmlFor="filter-start-date">Start:</label>
      <input
        type="datetime-local"
        id="filter-start-date"
        name="startDate"
        value={filter.startDate}
        onChange={handleFilterChange}
      />
      <label htmlFor="filter-end-date">End:</label>
      <input
        type="datetime-local"
        id="filter-end-date"
        name="endDate"
        value={filter.endDate}
        onChange={handleFilterChange}
      />
      {!isSkySatScenario && (
        <>
          <label htmlFor="filter-constellation">Constellation:</label>
          <select
            id="filter-constellation"
            name="constellation"
            value={filter.constellation}
            onChange={handleFilterChange}
          >
            <option value="All">All</option>
            {constellations.map((constellation) => (
              <option key={constellation} value={constellation}>
                {constellation}
              </option>
            ))}
          </select>

          <label htmlFor="filter-spectral-type">Spectral Type:</label>
          <select
            id="filter-spectral-type"
            name="spectralType"
            value={filter.spectralType}
            onChange={handleFilterChange}
          >
            <option value="All">All</option>
            {spectralTypes.map((spectralType) => (
              <option key={spectralType} value={spectralType}>
                {spectralType}
              </option>
            ))}
          </select>

          <label htmlFor="filter-resolution">Resolution:</label>
          <div className="resolution-slider">
            <RangeSlider
              value={normalizedResolution}
              min={minResolution}
              max={maxResolution}
              step={0.25}
              onChange={handleResolutionChange}
            />
            <span>
              {resolutionFilterIsActive
                ? `${normalizedResolution[0]}m - ${normalizedResolution[1]}m`
                : "All"}
            </span>
          </div>
        </>
      )}
    </div>
  );
}

export default FilterSection;
